import axios from 'axios';
import { attachAuthInterceptors } from '../../_shared/auth/authInterceptor';

/**
 * catalogSignalApi — 채택 시그널 적재 얇은 래퍼 (queue #678 §UAT-2026-07-13-R678 §R678-4④).
 * project-scaffold 는 common-showcase 를 import 하지 않는 feature 간 교차 결합 회피 관례
 * (#641/#631 계보)를 따라 `POST /api/eraf/catalog/signals` 전용 얇은 axios 래퍼를 별도
 * 보유한다. `showcaseApi.recordSignal` 과 동일 계약(TAKE/COPY 만 · fire-and-forget) — 호출부가
 * await 하지 않고 `.catch(() => {})` 로 실패를 삼킨다(§R662 원칙 계승).
 */
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE ?? '/api/eraf',
  headers: { 'Content-Type': 'application/json' },
});
attachAuthInterceptors(apiClient);

function getStoredToken(): string | null {
  return localStorage.getItem('access_token') ?? sessionStorage.getItem('access_token');
}

apiClient.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export type CatalogSignalType = 'TAKE' | 'COPY';

/** POST /api/eraf/catalog/signals — TAKE/COPY 만(DOWNLOAD 는 서버 zip 경로 전용 · 400) */
export function recordCatalogSignals(eventType: CatalogSignalType, moduleCodes: string[]): Promise<void> {
  return apiClient.post('/catalog/signals', { eventType, moduleCodes }).then(() => undefined);
}
